import React from 'react';
interface DiaryEntryProps {
  date: string;
  title: string;
  content: string;
}
export function DiaryEntry({
  date,
  title,
  content
}: DiaryEntryProps) {
  return <article className="relative bg-card rounded-xl p-6 md:p-8 mb-8 shadow-diary border border-brown/5" data-id="element-42">
      <div className="absolute top-0 left-0 w-1.5 h-full bg-forest/80 rounded-l-xl" data-id="element-43"></div>

      <div className="mb-4" data-id="element-44">
        <span className="inline-block font-handwriting text-xl text-brown/70 -rotate-2 mb-2" data-id="element-45">
          {date}
        </span>
        <h3 className="font-serif text-xl md:text-2xl font-bold text-forest" data-id="element-46">
          {title}
        </h3>
      </div>

      <div className="font-serif text-text/90 leading-relaxed space-y-4" data-id="element-47">
        {content.split('\n').map((paragraph, index) => <p key={index} data-id="element-48">{paragraph}</p>)}
      </div>
    </article>;
}